// eslint-disable-next-line no-use-before-define
import React, { useEffect, useLayoutEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { ConfigProvider, message, notification } from 'antd';
import langLocale from 'src/components/common/language/langLocale';
import { LANG_SWITCH, LangMessage } from 'src/store/common/language';
import Toload from 'src/components/common/toLoad';
import { lang } from 'src/api';
import Home from './layout/home';
import Login from './layout/login';
import Nofound from './layout/refused';
import NoAccess from './layout/refused/noAccess';
import ServiceException from './layout/refused/serviceException';
import SystemMaintenance from './layout/refused/systemMaintenance';
import useFetchState from 'src/utils/useFetchState';
import { store } from './store';
import { setUsername } from 'src/store/common/user';
import { arrayExtendsAt, checkFileError } from 'src/utils/utils';

type Props = {
    dispatch: React.Dispatch<any>;
    locale: string;
    Mes: LangMessage;
};
const App = (props: Props) => {
    const locale = localStorage.getItem('language') || 'es_ES';
    const { dispatch, Mes } = props;

    const [ loading, setLoading ] = useFetchState<boolean>(!!(!Mes && locale));

    const getLangResource = async () => {
        try {
            const res = await lang.getLangResource(locale);

            await dispatch({
                type: LANG_SWITCH,
                value: {
                    locale: locale,
                    message: res,
                },
            });
            setLoading(false);
        } catch (error: any) {
            // setLoading(false);
            message.error(error.toString());
            console.error('error', error);
            // location.href = '/500';
        }
    };

    message.config({
        maxCount: 1,
    });

    notification.config({
        maxCount: 1,
    });

    useLayoutEffect(() => {
        arrayExtendsAt();
    }, []);

    // 定义一个错误处理函数
    const handleError = (mesg: any) => {
        console.error('file-error', mesg);
        // 这里可以添加你的错误处理逻辑
        if (checkFileError(mesg)) {
            window.location.reload();
        }
    };

    useEffect(() => {
        // 保存原始的onerror处理函数（如果有的话）
        const originalOnError = window.onerror;
        // 设置新的onerror处理函数

        window.onerror = handleError;
        if (loading) {
            getLangResource();
        }
        window.onfocus = () => {
            // 获取当前store存储的用户信息
            let storeUser = store.getState().userInfo.sysUser.operatorGuid;
            // 获取localstorage存储的用户信息
            let locStore = JSON.parse(localStorage.getItem('persist:root')!);

            if (locStore && locStore.userInfo) {
                let localUserInfo = JSON.parse(locStore.userInfo);
                let localUser = localUserInfo.sysUser.operatorGuid;

                if (storeUser !== localUser) {// 判断当前登录用户是否一致
                    // eslint-disable-next-line no-console
                    // console.log('当前登录user不一致');
                    dispatch({
                        type: setUsername,
                        value: {
                            ip: localUserInfo.ip,
                            sysType: localUserInfo.sysType,
                            subName: localUserInfo.subName,
                            sysUser: {
                                operatorName: localUserInfo?.sysUser?.operatorName || '',
                                operatorId: localUserInfo?.sysUser?.operatorId || '',
                                operatorGuid: localUserInfo?.sysUser?.operatorGuid || '',
                                nodeNo: localUserInfo?.sysUser?.nodeNo || [],
                                groupList: localUserInfo?.sysUser?.groupList || '',
                                subSys: localUserInfo?.sysUser?.subSys || '',
                                username: localUserInfo?.sysUser?.operatorName || '',
                            },
                            sysRole: {
                                groupGuid: localUserInfo?.sysRole?.groupGuid || '',
                                groupName: localUserInfo?.sysRole?.groupName || '',
                            },
                        },
                    });
                }
            }
        };
        return () => {
            window.onerror = originalOnError;
        };
    }, []);

    return (
        <>
            {loading ? (
                <Toload />
            ) : (
                <ConfigProvider locale={langLocale[props.locale || locale]} componentSize='middle'>
                    <Switch>
                        <Route exact path='/' render={() => <Redirect to={'/login'} push />} />
                        <Route path='/home' component={Home} />
                        <Route path='/404' component={Nofound} />
                        <Route path='/403' component={NoAccess} />
                        <Route path='/500' component={ServiceException} />
                        <Route path='/502' component={SystemMaintenance} />
                        <Route path='/login' key='login' component={Login} />
                        <Route render={() => <Redirect to='/404' push />} />
                    </Switch>
                </ConfigProvider>
            )}
        </>
    );
};

export default connect((state: any) => ({
    locale: state.langSwitch.locale,
    Mes: state.langSwitch.message,
}))(App);
